<template>
  <v-container class="fill-height align-start" fluid>
    <v-row>
      <v-col cols="12" class="d-flex py-0 justify-center">
        <div class="align-center">
          <span class="headline mr-4">{{ $t("materialMappingLabel") }}</span>
        </div>
      </v-col>
    </v-row>
    <v-row class="mt-5">
      <v-col cols="12" class="d-lg-flex align-center justify-space-between">
        <v-btn
            small depressed height="40px" color="primary"
            class="mx-4"
            @click="exportCharacteristics"
            :loading="exportChars"
            :disabled="exportChars">
          <v-icon left>mdi-download</v-icon>
          {{ $t("exportLabel") }}
        </v-btn>
        <v-card width="660" flat>
          <v-card-subtitle>{{ $t("importCsvLabel") }}</v-card-subtitle>
          <v-card-text>
            <div class="d-flex align-center">
              <v-file-input dense outlined hide-details prepend-icon="" prepend-inner-icon="mdi-file-excel"
                            :label="$t('fileInputLabel')" @change="attachedCharEventHandler" class="mr-3"></v-file-input>
              <v-btn small depressed height="40px" color="primary" @click="importCharacteristics"
                     :disabled="!importFile.base64String || importChars" :loading="importChars">
                {{ $t("importLabel") }}</v-btn>
            </div>
          </v-card-text>
        </v-card>
        <v-btn class="mr-2 elevation-0" fab dark small color="primary" download="Characteristics.json"
               :href="jsonBase64File" v-if="jsonBase64File" title="Download JSON">
          <v-icon>mdi-code-json</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="py-0">
        <v-data-table
            :options.sync="options"
            :footer-props="chars.footerProps"
            :server-items-length="1"
            :page.sync="page"
            :items-per-page="amount"
            class="mb-5 mt-4"
            :hide-header="true"
            :headers="chars.headers"
            :items="chars.values"
            :loading="loading"
            :loading-text="$t('tableLoadingLabel')"
        >
          <template v-slot:item.characteristicCode="{item}">
            <div :class="{'font-weight-bold': item.characteristicParentID === null}">
              {{item.characteristicCode}}
            </div>
          </template>
          <template #item.actions="{ item }">
            <div class="d-flex">
              <v-btn
                  icon
                  color="primary"
                  class="mr-2"
                  outlined
                  x-small
                  fab
                  dark
                  @click="updateCharEventHandler(item)"
              >
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
            </div>
          </template>
          <template v-slot:no-data>
            {{$t('noDataAvailable')}}
          </template>
          <template v-slot:no-results>
            {{$t('noDataAvailable')}}
          </template>
<!--          <template v-slot:group.header="{ group, headers, toggle, isOpen, items }">-->
<!--            <td :colspan="headers.length">-->
<!--              <v-btn @click="toggle" x-small icon :ref="group">-->
<!--                <v-icon v-if="isOpen">mdi-minus</v-icon>-->
<!--                <v-icon v-else>mdi-plus</v-icon>-->
<!--              </v-btn>-->
<!--              <span class="mx-5 font-weight-bold">{{ group }} - {{items[0].characteristicDescription}} </span>-->
<!--            </td>-->
<!--          </template>-->
        </v-data-table>
        <v-pagination
            v-model="page"
            :length="pageCount"
            total-visible="20"
            @input="fetchCharacteristics()"
        ></v-pagination>
      </v-col>
    </v-row>

    <v-dialog v-model="updateUserCharModal" max-width="500px">
      <v-card class="pa-10">
        <v-card-title class="justify-center">
          {{ $t("updateUserCharacteristic") }}
        </v-card-title>
        <v-card-text class="pa-0">
          <v-container>
            <v-row>
              <v-form
                  ref="userCharacteristicForm"
                  v-model="valid"
                  lazy-validation>
                <v-col cols="12">
                  <div class="text-caption">{{$t('characteristicLabel')}}</div>
                  <div class="text-subtitle-2 black--text">
                    {{selectedChar.characteristicCode}}
                  </div>
                </v-col>
                <v-col cols="12">
                  <div class="text-caption">{{$t('characteristicValueLabel')}}</div>
                  <div class="text-subtitle-2 black--text">
                    {{selectedChar.labelDetailsText}}
                  </div>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                      dense
                      outlined
                      :label="$t('userCharacteristicLabel')"
                      :rules="[v => !!v || $t('requiredValueLabel')]"
                      v-model="selectedChar.userCharacteristicUserValue"
                      hide-details
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                      dense
                      outlined
                      :label="$t('userCharacteristicDescriptionLabel')"
                      :rules="[v => !!v || $t('requiredValueLabel')]"
                      v-model="selectedChar.userCharacteristicUserDescription"
                      hide-details
                  >
                  </v-text-field>
                </v-col>
              </v-form>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-row>
            <v-col cols="6">
              <v-btn
                  width="100%"
                  depressed
                  small
                  color="primary"
                  class=""
                  @click="updateChar"
              >
                {{ $t("saveDataLabel") }}
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn
                  width="100%"
                  small
                  class="mr-2"
                  color="red white--text"
                  @click="updateUserCharModal = false"
              >
                {{ $t("cancelLabel") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
<!--    <v-dialog-->
<!--        :close-delay="3000"-->
<!--        v-model="snackbar.show"-->
<!--        max-width="360"-->
<!--        overlay-opacity="0.3"-->
<!--    >-->
<!--      <v-card>-->
<!--        <div class="pa-4 pb-0">-->
<!--          <div class="subtitle-1 text-center" v-text="snackbar.message"></div>-->
<!--        </div>-->
<!--        <v-card-actions>-->
<!--          <v-btn-->
<!--              small-->
<!--              class="mx-auto"-->
<!--              color="primary"-->
<!--              @click="snackbar.show = false"-->
<!--          >-->
<!--            {{$t('closeLabel')}}-->
<!--          </v-btn>-->
<!--        </v-card-actions>-->
<!--      </v-card>-->
<!--    </v-dialog>-->
  </v-container>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "UserCharacteristics",
  data(){
    return {
      loading: true,
      valid: true,
      options: {},
      page: 1,
      pageCount: 1,
      amount: 10,
      sortBy:'',
      sortDesc: null,
      updateUserCharModal: false,
      snackbar: {
        show: true,
        message: "",
      },
      importFile: {
        base64String: "",
        fileName: "",
        fileExtension: "",
      },
      exportFile: {
        base64String: "",
        fileName: "Material_Mapping.csv",
      },
      importChars: false,
      exportChars: false,
      selectedChar: {},
      jsonBase64File: '',
      chars: {
        search: "",
        headers: [
          {
            text: this.$t('characteristicLabel'),
            value: "characteristicCode",
            width: "20%",
          },
          {
            text: this.$t('characteristicValueLabel'),
            value: "labelDetailsText",
            width: "20%",
          },
          {
            text: this.$t('userCharacteristicLabel'),
            value: "userCharacteristicUserValue",
            width: "25%",
          },
          {
            text: this.$t('userCharacteristicDescriptionLabel'),
            value: "userCharacteristicUserDescription",
            width: "25%",
          },
          {
            text: this.$t('actionsLabel'),
            width: "10%",
            value: "actions",
            sortable: false
          },
        ],
        values: [],
        footerProps:{
          'items-per-page-options' : [5, 10, 15, 20, -1],
          'disable-pagination': true,
          'next-icon': null,
          'prev-icon': null,
          'page-text' : '',
          'items-per-page-all-text': this.$t('allLabel'),
          'items-per-page-text': this.$t('rowsPerPageLabel')
        }
    },
  }},
  mounted() {
    this.fetchCharacteristics()
    this.generateJsonData()
  },
  computed: {
    ...mapGetters(['getCurrentUser'])
  },
  watch: {
    options: {
      handler(){
        const options = this.options;
        this.amount = options.itemsPerPage
        const sortBy = options.sortBy.length > 0 ? options.sortBy[0] : '';
        const sortDesc = options.sortDesc.length > 0 ? options.sortDesc[0] : null;
        this.sortBy = sortBy;
        this.sortDesc = sortDesc;
        this.fetchCharacteristics();
      },
      deep: true
    },
    updateUserCharModal: function (newValue, oldValue) {
      if(!newValue){
        this.$refs.userCharacteristicForm.resetValidation()
      }
    }
  },
  methods: {
    async fetchCharacteristics(){
      this.loading = true
      await this.axios
          .get(`/api/userCharacteristicValueDescription/getByUserIdWithPagination`, {
            params:{
              userId: this.getCurrentUser.userId,
              amount: this.amount,
              page: this.page,
              sortBy: this.sortBy,
              sortDesc: this.sortDesc
            }
          })
          .then(res => {
            this.pageCount = res.data.pages
            this.chars.values = res.data.results
          }).catch(error => {
            this.snackbar.message = error.message;
            this.snackbar.show = true
            this.$EventBus.$emit("snackbar", this.snackbar);
          })
          .finally(() => this.loading = false)
    },
    async exportCharacteristics(){
      this.exportChars = true
      this.exportFile.base64String = ""
      await this.axios.get('/api/userCharacteristicValueDescription/generateUserCharacteristicCsv', {
        params: {
          userId: this.getCurrentUser.userId
        }
      })
          .then(res => {
            let csvContent = decodeURIComponent(escape(window.atob(res.data)));
            const fileURL = window.URL.createObjectURL(new Blob(["\uFEFF"+csvContent], {type: "data:application/excel;base64",}));
            this.exportFile.base64String = fileURL;
            this.exportChars = false
            const a = document.createElement('a')
            a.href = fileURL
            a.download = "Material_Mapping.csv"
            a.click()
          })
          .catch(error => {
            this.snackbar.message = error.message;
            this.snackbar.show = true
            this.$EventBus.$emit("snackbar", this.snackbar);
            this.exportChars = false;
          })
    },
    attachedCharEventHandler(event) {
      if (typeof event !== "undefined") {
        const file = event;
        this.importFile.fileName = file.name.split(".")[0];
        this.importFile.fileExtension = file.name.split(".")[1];
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          this.importFile.base64String = reader.result.replace(
              /^data:.+;base64,/,
              ""
          );
        };
      } else {
        this.importFile.base64String = "";
        this.importFile.fileName = "";
        this.importFile.fileExtension = "";
      }
    },
    importCharacteristics(){
      this.importChars = true;
      const base64String = this.importFile.base64String.replace("77u/","");

      const data = {
        Base64String: base64String,
        UserId: this.getCurrentUser.userId
      };
      this.axios
          .post("api/userCharacteristicValueDescription/insertOrUpdateWithBatchCsv", data)
          .then((response) => {
            this.snackbar.message = this.$t("materialMappingImportedLabel");
            this.$EventBus.$emit("snackbar", this.snackbar);
            this.importChars = false;
            this.importFile.base64String = "";
            this.importFile.fileName = "";
            this.importFile.fileExtension = "";
            this.fetchCharacteristics()
            this.generateJsonData()
          })
          .catch((error) => {
            this.snackbar.message = error.message
            this.$EventBus.$emit("snackbar", this.snackbar);
            this.importChars = false;
          });
    },
    updateCharEventHandler(item){
      this.selectedChar = {...item}
      this.updateUserCharModal = true
    },
    updateChar(){
      if(!this.$refs.userCharacteristicForm.validate())
        return;
      const data = {
        ID: this.selectedChar.userCharacteristicID,
        UserID: this.getCurrentUser.userId,
        CharacteristicCode: this.selectedChar.characteristicCode,
        UserValue: this.selectedChar.userCharacteristicUserValue,
        UserDescription: this.selectedChar.userCharacteristicUserDescription
      }

      this.axios.post('/api/userCharacteristicValueDescription/insertOrUpdate', data)
          .then(res => {
            const data = res.data
            let findIndex = this.chars.values.findIndex(f =>
                parseInt(f.characteristicID) === parseInt(this.selectedChar.characteristicID))

            if (findIndex > -1){
              this.chars.values[findIndex].userCharacteristicID = data.id
              this.chars.values[findIndex].userCharacteristicUserValue = data.userValue
              this.chars.values[findIndex].userCharacteristicUserDescription = data.userDescription
            }

            this.snackbar.message = this.$t("userCharInsertUpdateLabel")
            this.$EventBus.$emit("snackbar", this.snackbar);
            this.generateJsonData()
          })
          .catch(error => {
            this.snackbar.message = this.$t("userCharInsertUpdateErrorLabel")
            this.$EventBus.$emit("snackbar", this.snackbar);
            console.log(error)
          })
          .finally(() => this.updateUserCharModal = false)
    },
    generateJsonData() {
      this.axios.get('/api/userCharacteristicValueDescription/getListForJsonByUserId', {
        params: {
          userId: this.getCurrentUser.userId,
        }
      }).then(response => {
        try {
          let data = decodeURIComponent(escape(atob(response.data)))
          let fileURL = window.URL.createObjectURL(new Blob([data]))
          this.jsonBase64File = fileURL;
        }
        catch (e) {
          console.log(e)
        }
      }).catch(error => {
        console.log(error)
      });
    },
  }
}
</script>

<style scoped>

</style>